module.exports = __webpack_public_path__ + "static/3-32a155c4c4965b2ac696f8343f367cc5.png";